import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimActKc2OtherData, BimCreateActKc2OtherCorrectionMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimCreateActKC2OtherCorrectionGql } from '../bimEditActKC2OtherCorrectionQueries';

interface IUseUerCreateActKC2Correction {
    onSuccess?: (data?: BimActKc2OtherData) => void;
}

const requestId = 'bimCreateActKC2OtherCorrection';

export const useBimCreateActKC2OtherCorrection = (props: IUseUerCreateActKC2Correction) => {
    const dispatch = useDispatch();
    const { onSuccess } = props;

    const [bimCreateActKC2OtherCorrectionReset] = useResetStoreData({
        requestId,
    });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimCreateActKc2OtherCorrectionMutation>) => {
            if (depsVars?.payload?.bimCreateActKC2OtherCorrection?.data) {
                onSuccess?.(depsVars?.payload?.bimCreateActKC2OtherCorrection?.data);
            }
            bimCreateActKC2OtherCorrectionReset(undefined);
        },
        [onSuccess, bimCreateActKC2OtherCorrectionReset],
    );

    const [, , , bimCreateActKC2OtherCorrectionRequest] = useRequest<BimCreateActKc2OtherCorrectionMutation>({
        requestId,
        query: bimCreateActKC2OtherCorrectionGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return useCallback(
        (primaryActKC2Id: number) => {
            dispatch(bimCreateActKC2OtherCorrectionRequest({ input: { primaryActKC2Id } }));
        },
        [bimCreateActKC2OtherCorrectionRequest, dispatch],
    );
};
